module.exports = __webpack_public_path__ + "static/media/currency_exchange_white_24dp.aa8deb07.svg";